document.addEventListener("DOMContentLoaded", () => {
    const target = document.getElementById("become-a-business-partner");
    if (!target) {
        return;
    }

    const scrollToTarget = (behavior = "smooth") => {
        const rect = target.getBoundingClientRect();
        const targetTop = rect.top + window.scrollY;
        const offset = (window.innerHeight / 2) - (rect.height / 2);
        const top = Math.max(0, targetTop - offset);

        window.scrollTo({ top, behavior });
    };

    const handleAnchorClick = (event) => {
        const link = event.target.closest('a[href*="#become-a-business-partner"]');
        if (!link) {
            return;
        }

        const href = link.getAttribute("href") || "";
        const isSamePage = href.startsWith("#") || href.split("#")[0] === "" || href.split("#")[0] === window.location.pathname;
        if (!isSamePage) {
            return;
        }

        event.preventDefault();
        scrollToTarget("smooth");
        if (window.history && window.history.replaceState) {
            window.history.replaceState(null, "", "#become-a-business-partner");
        } else {
            window.location.hash = "become-a-business-partner";
        }
    };

    document.addEventListener("click", handleAnchorClick);

    if (window.location.hash === "#become-a-business-partner") {
        // Let the layout settle before centering.
        window.setTimeout(() => scrollToTarget("auto"), 0);
    }
});
